import React, { useRef, useState } from "react";
import { useEffect } from "react";
import "../../css/cpm-realgrid-style.css"; // RealGrid CSS 추가
import "../../css/cpm-realgrid-custom-style.css"; // RealGrid CSS 추가
import { menuIdList } from "Layouts/LayoutMenuData";

/**
 *
 * User : 이연우
 * Date : 2023.05.19
 * @ file : Components/realgrid/CpmRealgrid.js
 * @ Desc : RealGrid Component
 * @param {Function} onLoad 그리드 초기 시작 함수
 * @param {string} id 그리드 id
 * @param {string} title 그리드 제목
 * @param {string} minHeight 최소 높이
 */
function CpmRealgrid({ onLoad, id, title, minHeight = '400px',pHeight = '' , minWidth = '300px' }) {
  const ref = useRef(null);
  const [height, setHeight] = useState("0");
 
  useEffect(() => {
      // 메뉴리스트가 전부 부러와진 후 onLoad
      if(Object.keys(menuIdList).length === 0){
        setTimeout(() => {
          onLoad();
        }, 500)
      } else{
        onLoad();
      }
      // 반응형 페이지 높이 꽉차게 설정
      if(!pHeight){
        setHeight(`calc(94vh - ${ref.current.getBoundingClientRect().top}px)`)
      }else{
        setHeight(pHeight);
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div ref={ref} id={id} style={{ height: height, minHeight: minHeight, width: "100%" , minWidth: minWidth }} title={title} readOnly></div>
    </>
  );
}

export default CpmRealgrid;
